export enum RouteType {
  WALK = 'walk',
  CAR = 'car',
}
